<template>
  <el-select
    :value="modelType"
    :popper-append-to-body="false"
    class="model-select"
    @change="onChangeModelSelect"
  >
    <el-option
      v-for="{ label, value } in modelTypeList"
      :key="value"
      :label="label"
      :value="value"
    />
  </el-select>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "ModelSelect",
  computed: {
    ...mapState("session", ["modelType", "modelTypeList"]),
    ...mapState("user", [
      "signedIn",
      "organized",
      "signInMethod",
      "organizationName",
      "specialOrganizationNameList",
    ]),
  },
  methods: {
    ...mapMutations("session", ["setModelType"]),
    ...mapMutations("user", ["setSignedInMethod"]),
    ...mapActions(["openSignInDialog"]),
    ...mapActions("user", ["handleFetchUserInfo"]),
    ...mapActions("session", ["handleFetchSessionTitleList"]),

    async onChangeModelSelect(value) {
      this.setModelType(value);
      const {
        signedIn,
        organized,
        signInMethod,
        organizationName,
        specialOrganizationNameList,
      } = this;
      if (!signedIn) {
        this.openSignInDialog();
        return;
      }
      if (
        !specialOrganizationNameList.includes(organizationName) &&
        organized &&
        signInMethod === "organizational" &&
        value === 2
      ) {
        const h = this.$createElement;
        const message = h("div", null, [
          h("p", null, [
            h("span", null, "您当前正处于"),
            h("strong", null, "机构权限"),
            h("span", null, "登录状态，"),
            h("strong", null, "暂未开放ChatGPT-4模型"),
            h("span", null, "，请切换至"),
            h("strong", null, "个人权限"),
            h("span", null, "体验。"),
          ]),
        ]);
        const options = {
          title: "切换权限",
          customClass: "responsive-message-box",
          cancelButtonClass: "el-button--float-right",
          confirmButtonText: "切换至个人权限登录",
        };
        await this.$confirm(message, options)
          .then(() => {
            this.setSignedInMethod("individual");
          })
          .catch(() => {
            this.setModelType(1);
          });
      }
      const { name: currentRouteName } = this.$route;
      const name = "Home";
      if (currentRouteName === name) {
        await this.handleFetchUserInfo().catch((error) => {
          console.error("onChangeModelSelect");
          throw error;
        });
        await this.handleFetchSessionTitleList().catch((error) => {
          console.error("onChangeModelSelect");
          throw error;
        });
        return;
      }
      this.$router.push({ name });
    },
  },
};
</script>

<style lang="scss" scoped>
.model-select {
  width: 160px;

  ::v-deep .el-input {
    font-size: 18px;

    .el-input__inner {
      border: none;
      font-weight: 600;
    }
  }
}
</style>